import React from "react";
import type { ViewComponent } from "@frui.ts/views/dist";
import { registerView } from "@frui.ts/views/dist";
import { observer } from "mobx-react-lite";
import RoadCreateViewModel from "viewModels/timeCharges/distributorEnums/roads/roadCreateViewModel";
import CreateView from "views/common/create";
import RoadForm from "./roadForm";

const RoadCreateView: ViewComponent<RoadCreateViewModel> = observer(({ vm }) => (
  <CreateView vm={vm} form={<RoadForm vm={vm} />} />
));

registerView(RoadCreateView, RoadCreateViewModel);
